// The API exposed to the "parent" page that is embedding SpeedyG in
// an iframe.  The parent page should use "postMessage" to send
// messages to SpeedyG.  For example, if "iframElem" points to
// SpeedyG's DOM element:
//
//  iframeElem.contentWindow.postMessage({eventType: "PREV_PAGE"}, "*")
//
export class SpeedyGClientApi {
  constructor(speedyg) {
    this.speedyg = speedyg

    // Listen for messages from the parent
    window.addEventListener("message", e=>{
      const eventType = e && e.data && e.data.eventType;
      switch(eventType) {
      case "PREV_PAGE":
        this.speedyg.showPrevPage()
        break;
      case "NEXT_PAGE":
        this.speedyg.showNextPage()
        break;
      }
    }, false)
  }
}
